import { ProductCard } from "@/components/ProductCard";
import { Skeleton } from "@/components/ui/skeleton";

const TABS = [
  { id: "all", label: "All" },
  { id: "beauty", label: "Beauty" },
  { id: "fashion", label: "Fashion" },
];

export const ProductGrid = ({ items, loading, error, filter, setFilter, search, onToggleLike, eyebrow = "Newest first", heading = "The Latest Edit" }) => (
  <section id="shop" data-testid="product-grid-section" className="bg-[#FBF9F5] px-4 sm:px-8 lg:px-12 py-16 lg:py-24 scroll-mt-16">
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12 lg:mb-16">
      <div>
        <p className="eyebrow mb-3">{eyebrow}</p>
        <h2 className="font-display text-3xl sm:text-4xl text-[#0F0F0F]">{heading}</h2>
        {search && <p data-testid="search-results-label" className="text-sm text-[#71717A] mt-3">Results for “{search}”</p>}
      </div>
      <div className="flex gap-8 border-b border-[#C5A059]/25">
        {TABS.map((t) => (
          <button
            key={t.id}
            data-testid={`filter-tab-${t.id}`}
            onClick={() => setFilter(t.id)}
            className={`pb-3 -mb-px text-xs uppercase tracking-[0.28em] border-b-2 transition-colors ${filter === t.id ? "border-[#C5A059] text-[#0F0F0F]" : "border-transparent text-[#71717A] hover:text-[#0F0F0F]"}`}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>

    {error ? (
      <p data-testid="product-grid-error" className="text-sm text-red-700">Couldn't load listings. Please refresh.</p>
    ) : loading ? (
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-3 sm:gap-x-8 gap-y-8 sm:gap-y-12">
        {Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="aspect-[3/4] rounded-none bg-[#F5EFE6]" />)}
      </div>
    ) : items.length === 0 ? (
      <p data-testid="product-grid-empty" className="font-display text-2xl text-[#71717A] py-20">Nothing here yet — check back soon.</p>
    ) : (
      <div data-testid="product-grid" className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-3 sm:gap-x-8 gap-y-8 sm:gap-y-12">
        {items.map((it, i) => <ProductCard key={it.id} item={it} index={i} onToggleLike={onToggleLike} />)}
      </div>
    )}
  </section>
);
